/**
 * セミナー申込ダイアログの機能
 */

// セミナー申込ダイアログの表示
function showSeminarApplicationDialog() {
    const dialog = document.getElementById('seminarApplicationDialog');
    if (dialog) {
        dialog.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }
}

// セミナー申込ダイアログを閉じる
function closeSeminarApplicationDialog() {
    const dialog = document.getElementById('seminarApplicationDialog');
    if (dialog) {
        dialog.style.display = 'none';
        document.body.style.overflow = 'auto';
    }
}

// セミナー申込を確認して送信
function confirmSeminarApplication() {
    // ローディング状態を表示
    const confirmBtn = document.querySelector('.seminar-dialog-footer .button--primary');
    const originalText = confirmBtn.innerHTML;
    confirmBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> 送信中...';
    confirmBtn.disabled = true;

    // AJAXで申込を送信
    const formData = new FormData();
    formData.append('action', 'seminar_application');
    formData.append('seminar_id', getSeminarIdFromUrl());
    formData.append('nonce', seminarDialogVars.nonce);

    fetch(seminarDialogVars.ajaxUrl, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // 成功時の処理
            closeSeminarApplicationDialog();
            alert('セミナーの申し込みが完了しました。');
            // 画面をリロードしてボタンの状態を反映
            window.location.reload();
        } else {
            // エラー時の処理
            alert('申し込みに失敗しました: ' + (data.data?.message || data.message || 'エラーが発生しました'));
        }
    })
    .catch(error => {
        alert('申し込みに失敗しました。');
    })
    .finally(() => {
        // ボタンを元の状態に戻す
        confirmBtn.innerHTML = originalText;
        confirmBtn.disabled = false;
    });
}

// URLからセミナーIDを取得
function getSeminarIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('seminar_id') || '1';
}

// ダイアログ外クリックで閉じる
document.addEventListener('DOMContentLoaded', function() {
    const dialog = document.getElementById('seminarApplicationDialog');
    if (dialog) {
        dialog.addEventListener('click', function(e) {
            if (e.target === dialog) {
                closeSeminarApplicationDialog();
            }
        });
    }
}); 